import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WindowWrapperService } from '../core/window-wrapper.service';
import { Config } from '../data-models/config.interfaces';

@Injectable({
  providedIn: 'root'
})
export class UrlUtilsService {
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private w: WindowWrapperService
  ) {}

  /**
   * Get a URL parameter.
   */
  getUrlParameter(parameter: string, defaultValue = ''): string {
    let parameterValue;

    if (this.activatedRoute?.snapshot?.paramMap) {
      parameterValue = this.activatedRoute.snapshot.paramMap.get(parameter);
    }

    if (!parameterValue) {
      parameterValue = this.getParameterByName(parameter);
    }

    return parameterValue || defaultValue;
  }

  /**
   * Get an array of url segments
   */
  // getUrlSegmentArray() {
  //   return this.router.events
  //     .pipe(filter((event) => event instanceof NavigationEnd))
  //     .pipe(
  //       map((route: NavigationEnd) => {
  //         const urlArray = route.url.split('/');
  //         urlArray.shift();
  //         return urlArray;
  //       })
  //     );
  // }

  /** get url query parameters */
  getQueryParameter(paramString: string): Observable<string> {
    // TODO - need to test the below logic to ensure it is working as expected
    // return this.activatedRoute.queryParams.map((val) => val[paramString]);
    return this.activatedRoute.queryParams.pipe(map((val) => val[paramString]));
  }

  /**
   * Get the current base url
   */
  getBaseUrl() {
    let url = `${this.getProtocol()}//${this.getHostname()}`;

    if (this.getPort() && this.getPort().length > 0) {
      url += `:${this.getPort()}`;
    }

    return url;
  }

  /**
   * Get the current protocol from url
   */
  getProtocol() {
    return window.location.protocol;
  }

  /**
   * Get the current port from url
   */
  getPort() {
    return window.location.port;
  }

  /**
   * Get the current hostname.
   */
  getHostname() {
    return window.location.hostname;
  }

  private getParameterByName(name: string, url = window.location.href): string {
    // TODO - need to test the below logic to ensure it is working as expected
    // const newName = name.replace(/[\[\]]/g, '\\$&');
    const newName = name.replace(/[[\]]/g, '\\$&');

    const regex = new RegExp('[?&]' + newName + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);

    if (!results || !results[2]) {
      return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  /**
   * Wrapper function for querySelectorAll
   */
  querySelectorAll(selector: string): NodeListOf<Element> {
    return this.w.getWindow().document.querySelectorAll(selector);
  }

  /**
   * Wrapper function for document.getElementsByTagName.
   */
  getElementsByTagName(name: string): HTMLCollectionOf<Element> {
    return this.w.getWindow().document.getElementsByTagName(name);
  }

  /**
   * Generate query params from Config object
   */
  getQueryString = (params: Config): string => {
    params = this.getValidParams(params);
    if (params && Object.keys(params).length) {
      let queryString = '?';
      queryString += Object.keys(params)
        .map(function (key: string) {
          return key + '=' + params[key];
        })
        .join('&');
      return queryString;
    }
    return '';
  };

  getValidParams = (params: Config) => {
    for (const key in params) {
      if (!params[key]) {
        delete params[key];
      }
    }
    return params;
  };
}
